// import { useSelector } from "react-redux";
// import SC from "./style";
// import TimezoneConverter from "components/TimeZoneConvertor";
// import { formatDate } from "utils/helper";

// const OccupantDetails = (props) => {
//   const { occupantData } = props;

//   const currentProject = useSelector(
//     (state) => state?.currentProject?.data || null
//   );

//   return (
//     <div style={{ padding: "10px 30px 0px 10px" }}>
//       <SC.HeaderStyle>Occupant Details</SC.HeaderStyle>
//       <SC.CardContainerStyle>
//         <SC.RowContainerStyle>
//           {/* <SC.RowStyle>
//             <SC.LabelContainerStyle>Occupant Name</SC.LabelContainerStyle>
//             <SC.ValueContainerStyle>
//               {occupantData?.occupantName || "N/A"}
//             </SC.ValueContainerStyle>
//           </SC.RowStyle> */}
//           <SC.RowStyle>
//             <SC.LabelContainerStyle>Opening Date</SC.LabelContainerStyle>
//             <SC.ValueContainerStyle>
//               {occupantData?.occupantOpeningDate || "N/A"}
//               {/* {occupantData?.occupantOpeningDate.split} */}
//             </SC.ValueContainerStyle>
//           </SC.RowStyle>

//           {/* <SC.RowStyle>
//             <SC.LabelContainerStyle>Released</SC.LabelContainerStyle>
//             <SC.ValueContainerStyle></SC.ValueContainerStyle>
//           </SC.RowStyle> */}
//           <SC.RowStyle>
//             <SC.LabelContainerStyle>Occupant Number</SC.LabelContainerStyle>
//             <SC.ValueContainerStyle>
//               {occupantData?.occupantNo || "N/A"}
//             </SC.ValueContainerStyle>
//           </SC.RowStyle>
//           {/* <SC.RowStyle>
//             <SC.LabelContainerStyle>Contact Number</SC.LabelContainerStyle>
//             <SC.ValueContainerStyle>(239) 555-0108</SC.ValueContainerStyle>
//           </SC.RowStyle> */}
//           <SC.RowStyle>
//             <SC.LabelContainerStyle>BO Period</SC.LabelContainerStyle>
//             <SC.ValueContainerStyle>
//               {occupantData.boPeriod ? `${occupantData.boPeriod} Days` : "N/A"}
//             </SC.ValueContainerStyle>
//           </SC.RowStyle>

//           <SC.RowStyle>
//             <SC.LabelContainerStyle>Occupant Size</SC.LabelContainerStyle>
//             <SC.ValueContainerStyle>
//               {occupantData?.occupantArea} {currentProject?.unit}
//             </SC.ValueContainerStyle>
//           </SC.RowStyle>
//           <SC.RowStyle>
//             <SC.LabelContainerStyle>
//               Occupant Release Date
//             </SC.LabelContainerStyle>
//             <SC.ValueContainerStyle>
//               {/* {occupantData?.tenantReleaseDate || "N/A"} */}
//               {formatDate(
//                 (<TimezoneConverter time={occupantData?.tenantReleaseDate} />)
//                   .props.time
//               )}
//             </SC.ValueContainerStyle>
//           </SC.RowStyle>
//           <SC.RowStyle>
//             <SC.LabelContainerStyle>BO Date</SC.LabelContainerStyle>
//             <SC.ValueContainerStyle>
//               {occupantData?.boEndDate}
//             </SC.ValueContainerStyle>
//           </SC.RowStyle>

//           <SC.RowStyle>
//             <SC.LabelContainerStyle>Coordinator</SC.LabelContainerStyle>
//             <SC.ValueContainerStyle>
//               {occupantData?.CoordinatorName || "N/A"}
//             </SC.ValueContainerStyle>
//           </SC.RowStyle>
//           <SC.RowStyle>
//             <SC.LabelContainerStyle>ORS Issued</SC.LabelContainerStyle>
//             <SC.ValueContainerStyle>
//               {occupantData?.trsIssuedOn || "N/A"}
//             </SC.ValueContainerStyle>
//           </SC.RowStyle>
//           {/* <SC.RowStyle>
//             <SC.LabelContainerStyle>Trading Date</SC.LabelContainerStyle>
//             <SC.ValueContainerStyle>{""}</SC.ValueContainerStyle>
//           </SC.RowStyle> */}
//         </SC.RowContainerStyle>
//       </SC.CardContainerStyle>
//     </div>
//   );
// };

// export default OccupantDetails;

import React from "react";
import { useSelector } from "react-redux";
import SC from "./style";
import TimezoneConverter from "components/TimeZoneConvertor";
import { formatDate } from "utils/helper";
import InnoIcons from "InnoUI/innoicons";
import { tenantReleaseStatus } from "utils/optionData/utils";

const statusColors = { 0: "#f59e0b", 1: "#22c55e", 2: "#3b82f6" };

const OccupantDetails = (props) => {
  const { occupantData } = props;

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || null,
  );

  console.log(occupantData, "occupantData");

  return (
    <>
      <SC.HeaderStyle>Occupant Details</SC.HeaderStyle>
      <SC.Container>
        <SC.DetailsGrid>
          {occupantData?.occupantOpeningDate && (
            <SC.DetailItem>
              <SC.LabelContainer>
                <SC.LabelIcon>
                  <InnoIcons.CalendarMonthIcon />
                </SC.LabelIcon>
                <SC.Label>Opening Date</SC.Label>
              </SC.LabelContainer>
              <SC.Value>{occupantData?.occupantOpeningDate}</SC.Value>
            </SC.DetailItem>
          )}

          {occupantData?.occupantNo && (
            <SC.DetailItem>
              <SC.LabelContainer>
                <SC.LabelIcon>
                  <InnoIcons.AccountBoxIcon />
                </SC.LabelIcon>
                <SC.Label>Occupant Number</SC.Label>
              </SC.LabelContainer>
              <SC.Value>{occupantData?.occupantNo}</SC.Value>
            </SC.DetailItem>
          )}

          {occupantData?.tenantStatus !== undefined &&
            occupantData?.tenantStatus !== null && (
              <SC.DetailItem>
                <SC.LabelContainer>
                  <SC.LabelIcon>
                    <InnoIcons.DescriptionOutlinedIcon />
                  </SC.LabelIcon>
                  <SC.Label>Release Status</SC.Label>
                </SC.LabelContainer>
                <SC.Value>
                  <span
                    style={{
                      display: "inline-block",
                      padding: "2px 10px",
                      borderRadius: "12px",
                      fontSize: "12px",
                      fontWeight: 500,
                      background:
                        statusColors[occupantData.tenantStatus] + "20",
                      color: statusColors[occupantData.tenantStatus],
                      border: `1px solid ${statusColors[occupantData.tenantStatus]}`,
                    }}
                  >
                    {tenantReleaseStatus.find(
                      (s) => s.id === Number(occupantData.tenantStatus),
                    )?.label || "N/A"}
                  </span>
                </SC.Value>
              </SC.DetailItem>
            )}

          {occupantData?.boPeriod && (
            <SC.DetailItem>
              <SC.LabelContainer>
                <SC.LabelIcon>
                  <InnoIcons.ClockCircleOutlined />
                </SC.LabelIcon>
                <SC.Label>BO Period</SC.Label>
              </SC.LabelContainer>
              <SC.Value>
                {occupantData.boPeriod
                  ? `${occupantData.boPeriod} Days`
                  : "N/A"}
              </SC.Value>
            </SC.DetailItem>
          )}

          {occupantData?.occupantArea && (
            <SC.DetailItem>
              <SC.LabelContainer>
                <SC.LabelIcon>
                  <InnoIcons.AdjustIcon />
                </SC.LabelIcon>
                <SC.Label>Occupant Size</SC.Label>
              </SC.LabelContainer>
              <SC.Value>
                {occupantData?.occupantArea} {currentProject?.unit}
              </SC.Value>
            </SC.DetailItem>
          )}

          {occupantData?.tenantReleaseDate && (
            <SC.DetailItem>
              <SC.LabelContainer>
                <SC.LabelIcon>
                  <InnoIcons.ArrowForwardIosIcon />
                </SC.LabelIcon>
                <SC.Label>Occupant Release Date</SC.Label>
              </SC.LabelContainer>
              <SC.Value>
                {/* <TimezoneConverter time={occupantData?.tenantReleaseDate} /> */}

                {formatDate(
                  (<TimezoneConverter time={occupantData?.tenantReleaseDate} />)
                    .props.time,
                )}
              </SC.Value>
            </SC.DetailItem>
          )}

          {occupantData?.boEndDate && (
            <SC.DetailItem>
              <SC.LabelContainer>
                <SC.LabelIcon>
                  <InnoIcons.ClockCircleOutlined />
                </SC.LabelIcon>
                <SC.Label>BO Date</SC.Label>
              </SC.LabelContainer>
              <SC.Value> {occupantData?.boEndDate}</SC.Value>
            </SC.DetailItem>
          )}

          {occupantData?.CoordinatorName && (
            <SC.DetailItem>
              <SC.LabelContainer>
                <SC.LabelIcon>
                  <InnoIcons.PersonRoundedIcon />
                </SC.LabelIcon>
                <SC.Label>Coordinator</SC.Label>
              </SC.LabelContainer>
              <SC.Value> {occupantData?.CoordinatorName || "N/A"}</SC.Value>
            </SC.DetailItem>
          )}

          {occupantData?.trsIssuedOn && (
            <SC.DetailItem>
              <SC.LabelContainer>
                <SC.LabelIcon>
                  <InnoIcons.DescriptionOutlinedIcon />
                </SC.LabelIcon>
                <SC.Label>ORS Issued</SC.Label>
              </SC.LabelContainer>
              <SC.Value>{occupantData?.trsIssuedOn || "N/A"}</SC.Value>
            </SC.DetailItem>
          )}
        </SC.DetailsGrid>
      </SC.Container>
    </>
  );
};

export default OccupantDetails;
